import { LandingNav, PricingSection } from '@/components/landing'

export function PricingPage() {
  return (
    <div className="min-h-screen bg-primary-bg">
      <LandingNav />
      <PricingSection />
    </div>
  )
}
